import { useState } from 'react';
import './brand.css';

/** Light uses the supplied white artwork; dark uses the supplied black artwork. */
export function BrandLogo({
  tone = 'dark',
  compact = false,
  className = '',
}: {
  tone?: 'light' | 'dark';
  compact?: boolean;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  return (
    <span
      className={`tia-brand-logo tia-brand-${tone} ${compact ? 'tia-brand-compact' : ''} ${className}`}
      role="img"
      aria-label="The Indian Agency — Real Estate"
    >
      {!failed ? (
        <img
          src={`/brand/the-indian-agency-${tone === 'light' ? 'white' : 'black'}.png`}
          alt=""
          aria-hidden="true"
          width="691"
          height="435"
          onError={() => setFailed(true)}
        />
      ) : (
        <span className="tia-brand-type" aria-hidden="true">
          THE INDIAN<strong>AGENCY</strong>
          <small>REAL ESTATE</small>
        </span>
      )}
    </span>
  );
}

export default BrandLogo;
